import { sync } from '@genesislcap/foundation-utils';
import { html, ref } from '@microsoft/fast-element';
import { positionIcon } from '../../../../../styles';
import type { DrilldownFloatingPriceGraph } from './drilldown-floating-price-graph';

export enum OUTCOMES_ENUM {
  P05 = 'P05',
  MEAN = 'Mean',
  P95 = 'P95',
}

export enum GRAPH_SCENARIO {
  BASELINE = 'Baseline',
  HIGH_GAS = 'HighGas',
  LOW_GAS = 'LowGas'
}

export const DrilldownFloatingPriceGraphTemplate = html<DrilldownFloatingPriceGraph>`
    <div class="graph-div""> 
        <div class="title-menu">
            <div class="graph-title">Floating Price</div>
            <div class="criteria-selection">
                <div class="scenario-control">
                <label class="control-label">Scenario</label>
                <zero-segmented-control
                    appearance="primary"
                    orientation="horizontal"
                    :disabled=${(x) => x.disabledOptionsButton}
                    :value="${sync((x) => x.scenario)}"
                >
                    <zero-segmented-item value=${
                      GRAPH_SCENARIO.BASELINE
                    } class="custom-segmented-item">
                    Baseline
                    </zero-segmented-item>
                    <zero-segmented-item value=${
                      GRAPH_SCENARIO.HIGH_GAS
                    } class="custom-segmented-item">
                    High Gas
                    </zero-segmented-item>
                    <zero-segmented-item value=${
                      GRAPH_SCENARIO.LOW_GAS
                    } class="custom-segmented-item">
                    Low Gas
                    </zero-segmented-item>
                </zero-segmented-control>
                </div>
                <div class="outcome-control">
                <label class="control-label">Outcomes</label>
                <zero-segmented-control
                    appearance="primary"
                    orientation="horizontal"
                    :value="${sync((x) => x.outcome)}"
                >
                    <zero-segmented-item :disabled=${(x) => x.disabledOptionsButton} value=${
  OUTCOMES_ENUM.P05
} class="custom-segmented-item">
                    P05
                    </zero-segmented-item>
                    <zero-segmented-item :disabled=${(x) => x.disabledOptionsButton} value=${
  OUTCOMES_ENUM.MEAN
} class="custom-segmented-item">
                    Mean
                    </zero-segmented-item>
                    <zero-segmented-item :disabled=${(x) => x.disabledOptionsButton} value=${
  OUTCOMES_ENUM.P95
} class="custom-segmented-item">
                    P95
                    </zero-segmented-item>
                </zero-segmented-control>
                </div>
            </div>
        </div>
        <div ${ref('floatingPriceChart')}></div>
    </div>
`;
